import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'hooks';

import { isOffline as isOfflineSelector } from 'modules/healthCheck/selectors';
import { isCourtesyUnavailable, hasErrorOnKiosk } from 'modules/dealers/selectors';

import type { HomeButtonProps } from './index';
import HomeButton from './HomeButton';
import { BASE_ANALYTICS_CONFIG } from './constants';

const FROM_HOME_ANALYTICS = {
  ...BASE_ANALYTICS_CONFIG,
  action: 'From home login',
};

const FROM_DEALERSHIP_ANALYTICS = {
  ...BASE_ANALYTICS_CONFIG,
  action: 'From the dealership login',
};

const SelfServiceOriginButtons: React.FC<HomeButtonProps> = ({ onClick }) => {
  const disabled = useSelector(isOfflineSelector);
  const hasKioskError = useSelector(hasErrorOnKiosk);
  const isCourtesyNotAvailable = useSelector(isCourtesyUnavailable);

  const isFromDealershipDisabled = hasKioskError || isCourtesyNotAvailable;

  const handleClick = React.useCallback((atDealership: boolean) => () => onClick({ atDealership }), [onClick]);

  return (
    <div className="flex gap-8 w-full mx-auto pt-6 pb-12 max-w-4xl px-7 sm:flex-col sm:mt-auto sm:gap-home-buttons-gap sm:px-[var(--size-padding-x-home-buttons,1.75rem)] sm:pb-[var(--size-padding-bottom-home-buttons,3rem)] sm:max-w-[var(--max-w-home-buttons,56rem)]">
      <HomeButton
        disabled={disabled}
        icon="fb-icon--home"
        testId="from-home-button"
        onClick={handleClick(false)}
        analytics={FROM_HOME_ANALYTICS}
        label={<FormattedMessage id="home.fromHome" defaultMessage="From home" />}
      />
      <HomeButton
        disabled={disabled}
        testId="from-dealer-button"
        onClick={handleClick(true)}
        icon="fb-icon--from-dealership"
        analytics={FROM_DEALERSHIP_ANALYTICS}
        disabledStyle={isFromDealershipDisabled}
        label={<FormattedMessage id="home.fromDealer" defaultMessage="From the dealership" />}
      />
    </div>
  );
};

export default SelfServiceOriginButtons;
